/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CustomerDashboardResponse } from '../models/customer-dashboard-response';
import { DashboardOfferListItemResponse } from '../models/dashboard-offer-list-item-response';
import { GeneralApiResponse } from '../models/general-api-response';
import { ListApiResponse } from '../models/list-api-response';
import { PspDashboardForecastResponse } from '../models/psp-dashboard-forecast-response';
import { PspDashboardResponse } from '../models/psp-dashboard-response';

@Injectable({
  providedIn: 'root',
})
export class DashboardService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getCustomerDashboardOffersList
   */
  static readonly GetCustomerDashboardOffersListPath = '/api/web/v1/customers/{customer}/dashboard/offers';

  /**
   * Get Customer Offers List.
   *
   * **Accessible only for users with role 'ROLE_CUSTOMER_USER'**
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomerDashboardOffersList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerDashboardOffersList$Response(params: {

    /**
     * Customer Id.
     */
    customer: number;

    /**
     * Page number in pagination.
     */
    page?: any;

    /**
     * Size number in pagination.
     */
    size?: any;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<ListApiResponse & {
'data'?: Array<DashboardOfferListItemResponse>;
}>> {

    const rb = new RequestBuilder(this.rootUrl, DashboardService.GetCustomerDashboardOffersListPath, 'get');
    if (params) {
      rb.path('customer', params.customer, {});
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListApiResponse & {
        'data'?: Array<DashboardOfferListItemResponse>;
        }>;
      })
    );
  }

  /**
   * Get Customer Offers List.
   *
   * **Accessible only for users with role 'ROLE_CUSTOMER_USER'**
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCustomerDashboardOffersList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerDashboardOffersList(params: {

    /**
     * Customer Id.
     */
    customer: number;

    /**
     * Page number in pagination.
     */
    page?: any;

    /**
     * Size number in pagination.
     */
    size?: any;
    context?: HttpContext
  }
): Observable<ListApiResponse & {
'data'?: Array<DashboardOfferListItemResponse>;
}> {

    return this.getCustomerDashboardOffersList$Response(params).pipe(
      map((r: StrictHttpResponse<ListApiResponse & {
'data'?: Array<DashboardOfferListItemResponse>;
}>) => r.body as ListApiResponse & {
'data'?: Array<DashboardOfferListItemResponse>;
})
    );
  }

  /**
   * Path part for operation getCustomerDashboardGet
   */
  static readonly GetCustomerDashboardGetPath = '/api/web/v1/customers/{customer}/dashboard';

  /**
   * Get Customer dashboard data.
   *
   * **Accessible only for users with permission 'FEATURE_VIEW_DASHBOARD'**
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomerDashboardGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerDashboardGet$Response(params: {

    /**
     * Customer Id.
     */
    customer: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<GeneralApiResponse & {
'data'?: CustomerDashboardResponse;
}>> {

    const rb = new RequestBuilder(this.rootUrl, DashboardService.GetCustomerDashboardGetPath, 'get');
    if (params) {
      rb.path('customer', params.customer, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GeneralApiResponse & {
        'data'?: CustomerDashboardResponse;
        }>;
      })
    );
  }

  /**
   * Get Customer dashboard data.
   *
   * **Accessible only for users with permission 'FEATURE_VIEW_DASHBOARD'**
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCustomerDashboardGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerDashboardGet(params: {

    /**
     * Customer Id.
     */
    customer: number;
    context?: HttpContext
  }
): Observable<GeneralApiResponse & {
'data'?: CustomerDashboardResponse;
}> {

    return this.getCustomerDashboardGet$Response(params).pipe(
      map((r: StrictHttpResponse<GeneralApiResponse & {
'data'?: CustomerDashboardResponse;
}>) => r.body as GeneralApiResponse & {
'data'?: CustomerDashboardResponse;
})
    );
  }

  /**
   * Path part for operation getPspDashboardGetForecast
   */
  static readonly GetPspDashboardGetForecastPath = '/api/web/v1/psps/{psp}/dashboard/forecast';

  /**
   * Get forecaster for dashboard.
   *
   * **Accessible only for users with permission 'FEATURE_VIEW_DASHBOARD'**
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPspDashboardGetForecast()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPspDashboardGetForecast$Response(params: {

    /**
     * PSP Id.
     */
    psp: number;

    /**
     * Start date, including.
     */
    from: string;

    /**
     * End date, including.
     */
    to: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<GeneralApiResponse & {
'data'?: PspDashboardForecastResponse;
}>> {

    const rb = new RequestBuilder(this.rootUrl, DashboardService.GetPspDashboardGetForecastPath, 'get');
    if (params) {
      rb.path('psp', params.psp, {});
      rb.query('from', params.from, {});
      rb.query('to', params.to, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GeneralApiResponse & {
        'data'?: PspDashboardForecastResponse;
        }>;
      })
    );
  }

  /**
   * Get forecaster for dashboard.
   *
   * **Accessible only for users with permission 'FEATURE_VIEW_DASHBOARD'**
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPspDashboardGetForecast$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPspDashboardGetForecast(params: {

    /**
     * PSP Id.
     */
    psp: number;

    /**
     * Start date, including.
     */
    from: string;

    /**
     * End date, including.
     */
    to: string;
    context?: HttpContext
  }
): Observable<GeneralApiResponse & {
'data'?: PspDashboardForecastResponse;
}> {

    return this.getPspDashboardGetForecast$Response(params).pipe(
      map((r: StrictHttpResponse<GeneralApiResponse & {
'data'?: PspDashboardForecastResponse;
}>) => r.body as GeneralApiResponse & {
'data'?: PspDashboardForecastResponse;
})
    );
  }

  /**
   * Path part for operation getPspDashboardGet
   */
  static readonly GetPspDashboardGetPath = '/api/web/v1/psps/{psp}/dashboard';

  /**
   * Get PSP dashboard data.
   *
   * **Accessible only for users with permission 'FEATURE_VIEW_DASHBOARD'**
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPspDashboardGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPspDashboardGet$Response(params: {

    /**
     * PSP Id.
     */
    psp: number;

    /**
     * PSP Branch to filter Assignments Count by
     */
    assignmentBranch?: any;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<GeneralApiResponse & {
'data'?: PspDashboardResponse;
}>> {

    const rb = new RequestBuilder(this.rootUrl, DashboardService.GetPspDashboardGetPath, 'get');
    if (params) {
      rb.path('psp', params.psp, {});
      rb.query('assignmentBranch', params.assignmentBranch, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GeneralApiResponse & {
        'data'?: PspDashboardResponse;
        }>;
      })
    );
  }

  /**
   * Get PSP dashboard data.
   *
   * **Accessible only for users with permission 'FEATURE_VIEW_DASHBOARD'**
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPspDashboardGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPspDashboardGet(params: {

    /**
     * PSP Id.
     */
    psp: number;

    /**
     * PSP Branch to filter Assignments Count by
     */
    assignmentBranch?: any;
    context?: HttpContext
  }
): Observable<GeneralApiResponse & {
'data'?: PspDashboardResponse;
}> {

    return this.getPspDashboardGet$Response(params).pipe(
      map((r: StrictHttpResponse<GeneralApiResponse & {
'data'?: PspDashboardResponse;
}>) => r.body as GeneralApiResponse & {
'data'?: PspDashboardResponse;
})
    );
  }

}
